import moment from 'moment';
import { TODAY } from '../../../constants/dateRanges';
import { MY_TEAM } from '../../../constants/teamNames';
import AlertType from '../../../constants/alertType';

const initialState = () => ({
  // Landing Page
  myTeamTodayCounts: [],
  myTeamThisWeekCounts: [],
  myTeamCustomCounts: [],
  otherTeamsTodayCounts: [],
  otherTeamsThisWeekCounts: [],
  otherTeamsCustomCounts: [],

  myTeamTodayAlerts: [],
  myTeamThisWeekAlerts: [],
  myTeamCustomAlerts: [],
  otherTeamsTodayAlerts: [],
  otherTeamsThisWeekAlerts: [],
  otherTeamsCustomAlerts: [],
  alertsForSubscription: [],
  subscriptions: [],

  selectedAlert: AlertType.schedule,
  selectedTeamName: MY_TEAM,
  selectedDateRange: TODAY,
  selectedDateRangePicker: [moment().subtract(7, 'days').format('YYYY[-]MM[-]DD'), moment(new Date()).format('YYYY[-]MM[-]DD')],
});
export default initialState;
